import { Select, type SelectProps, type GetRef } from 'antd'
import { forwardRef, type ForwardRefRenderFunction } from 'react'
import { useQuery } from '@tanstack/react-query'
import { apiGetTimezones } from '~/api/adminApi'

type BaseSelectRef = GetRef<typeof Select>

const TimezoneSelectFwdRef: ForwardRefRenderFunction<BaseSelectRef, SelectProps> = (props, ref) => {
  const { data: timezones } = useQuery({
    queryKey: ['timezones'],
    queryFn: async () => await apiGetTimezones()
  })

  return (
    <Select
      placeholder="Please select timezone"
      showSearch
      optionFilterProp="label"
      allowClear
      options={
        timezones?.map((item) => ({
          label: `${item.timezone} (${item.gmt_offset.trim()})`,
          value: item.timezone
        }))
      }
      ref={ref}
      {...props}
    />
  )
}

export const TimezoneSelect = forwardRef(TimezoneSelectFwdRef)
